export enum ClientReferralTaskChoice {
  yes = 'yes',
  notYet = 'not_yet',
  no = 'no',
  prescriberIsCeProvider = 'prescriber_is_ce_provider',
}
